
export class SitesTableObject {

  constructor(public id: number, private name: string, private role: string, private numberOfContacts: number) {

  }

  public static create() {
    return new SitesTableObject(0, '', '', 0);

  }

  public getName(): string {
    return this.name;
  }

  public getRole(): string {
    return this.role;
  }

  public getNumberOfContacts(): number {
    return this.numberOfContacts;
  }
}
